import { useEffect } from 'react';
import { DashboardHeader } from '@/src/modules/components/Header';
import { Icons } from '@/src/modules/components/Icons';
import { GradientButton } from '@/src/modules/components/ui/gradient-button';
import { motion } from 'motion/react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/src/modules/auth/AuthProvider';
import { PublishCreditsCard } from '@/src/modules/entitlements/components/PublishCreditsCard';
import { PurchaseFaultBanner } from '@/src/modules/purchase-faults/PurchaseFaultBanner';
import { trackEvent } from '@/src/infrastructure/lib/analytics';
import { BrowseCatalogSection } from '@/src/modules/pages/dashboard/BrowseCatalogSection';

export function Dashboard() {
  const { user } = useAuth();

  useEffect(() => { trackEvent('DASHBOARD_VIEW', 'navigation'); }, []);

  return (
    <div className="flex-1 flex flex-col min-h-screen bg-surface-lowest pb-20 md:pb-8">
      <DashboardHeader
        title="Dashboard"
        description={`Welcome back${user?.displayName ? ', ' + user.displayName : ''}. Create and manage your invitations.`}
      />

      <div className="px-8 py-8 max-w-7xl mx-auto w-full">
        {/* Hero */}
        <motion.section
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="relative mb-10 rounded-[2rem] overflow-hidden bg-gradient-to-br from-primary/10 via-surface to-surface p-8 md:p-12 border border-outline-variant/20"
        >
          <div className="absolute top-0 right-0 -mr-[10%] -mt-[20%] w-[40%] h-[80%] rounded-full bg-primary/15 blur-[100px] pointer-events-none" />
          <div className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div className="max-w-2xl">
              <h1 className="text-3xl md:text-4xl font-bold text-on-surface mb-3 leading-tight">
                Create Your Next Invitation
              </h1>
              <p className="text-on-surface-variant">
                Create beautiful invitations for any occasion. Choose an event and start from a
                professionally designed template.
              </p>
            </div>
            <Link to="/wizard" className="flex-shrink-0">
              <GradientButton className="flex items-center gap-2 whitespace-nowrap">
                <Icons.Plus size={18} />
                Create Invitation
              </GradientButton>
            </Link>
          </div>
        </motion.section>

        <PurchaseFaultBanner />

        {/* Publishing Rights */}
        <div className="mb-12">
          <PublishCreditsCard />
        </div>

        {/* Browse Invitation Designs — same catalog as /catalog */}
        <BrowseCatalogSection />
      </div>
    </div>
  );
}
